import Vue from "vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import VueSweetalert2 from "vue-sweetalert2";
import IdleVue from "idle-vue";
import VueMask from "v-mask";
import money from "v-money";
import moment from "moment";
import Vuelidate from 'vuelidate';
import "regenerator-runtime/runtime";

import App from "./App.vue";
import store from "./store";
import router from "./router";

window._ = require("lodash");
window.moment = moment;

Vue.prototype.moment = moment;
Vue.use(VueMask);
Vue.use(Vuelidate)
Vue.use(money);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(IdleVue, {
  moduleName: "CARBON_IDLE_WARN",
  idleTime: 150000, // 2.5 minutes
  store
});

const VueSweetalert2Options = {
  target: ".appWrapper",
  reverseButtons: true,
  confirmButtonColor: "#4300c2",
  cancelButtonColor: "#a3a3a3"
};
Vue.use(VueSweetalert2, VueSweetalert2Options);

try {
  window.$ = window.jQuery = require("jquery");
} catch (e) {}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default Vue;
